const moment: any = require("moment");
import * as _ from 'lodash';

require('./car.less');

class CarController {
    weekMode: boolean;
    listOfListOfCars;
    activeDate = new Date();
    urlListener;
    activeState;
    hasContent: boolean;
    fromDate: Date;
    toDate: Date;
    weekNumber: number;
    year: number;
    numberOfWeeks: number;
    weeks = [];
    years = [];
    datesInWeek;

    loadingDocumentIcon = {
        name: 'file_download',
        tooltip: 'Last ned lastedokument',
        functionCall: (event, line) => this.getLoadingDocument(event, line)
    };

    structureLevelPickedIcon = {
        name: (row) => row.structureError ? 'flag' : '',
        tooltip: (row) => row.structureError ? 'Strukturvare del-plukket' : '',
        color: '#F44336'
    };

    pickStatusIcon = {
        name: (row) => {
            return row.picklistCount === 0 ? '' : row.lineCount === row.picklistCount ? 'playlist_add_check' : 'playlist_add';
        },
        tooltip: (row) => {
            return row.picklistCount === 0 ? '' : row.lineCount === row.picklistCount ? 'Alle varelinjer tildelt plukkliste' : 'Varelinjer delvis tildelt plukkliste';
        }
    };

    tableDefinition = {
        settings: {
            minimizable: true,
            minimizedOnInit: false,
            hidePaginator: true,
            editFunction: (event, car) => this.rowClicked(event, car),
            promise: null
        },
        columns: [
            {title: '', icon: this.structureLevelPickedIcon},
            {title: 'BID', name: 'bookingId'},
            {title: 'Name', name: 'terminals', columnWidth: '550px'},
            {title: '', icon: this.loadingDocumentIcon},
            {title: '', icon: this.pickStatusIcon},
            {title: 'Varelinjer totalt', name: 'lineCount', type: 'number'},
            {title: 'Varelinjer plukket', name: 'pickedCount', type: 'number'},
            {title: 'Varelinjer gjenstående', name: 'linesRemaining', type: 'number'},
            {title: '% ferdig', name: 'percentDone', type: 'percent'},
        ]
    };

    constructor(private $state, private PickStatus, private $filter, private toastService, private $location, private $scope) {
        this.urlListener = $scope.$on('$locationChangeSuccess', () => {
            if (this.activeState === this.$state.current.name) {
                this.setDatesFromUrl();
                this.getPickStatusBookings();
            }
        });
    }

    $onInit() {
        this.weekMode = 'loggedin.expedition_distribution_week' === this.$state.current.name;
        if (this.weekMode) {
            this.defineWeeks();
            this.defineYears();
            this.setCurrentWeekNumber();
            this.setCurrentYear();
            this.setDatesFromUrl();
            this.setDateRange();
        } else {
            this.setDatesFromUrl();
            this.setDate();
        }
        this.getPickStatusBookings();
        this.activeState = angular.copy(this.$state.current.name);
    }

    $onDestroy() {
        this.urlListener();
    }

    setDatesFromUrl() {
        this.fromDate = this.$location.$$search.fromDate ? new Date(this.$location.$$search.fromDate) : undefined;
        this.toDate = this.$location.$$search.toDate ? new Date(this.$location.$$search.toDate) : undefined;

        if ((this.fromDate || this.toDate) && this.weekMode) {
            this.setCurrentWeekNumber(this.fromDate || this.fromDate);
            this.setCurrentYear(this.fromDate || this.toDate);
        }
    }

    getLoadingDocument(event, line) {
        window.open("/api/wms/pickstatus/loadingdocument?date=" + this.$filter('date')(line.deliveryDate, 'yyyy-MM-dd') + "&bookingId=" + line.bookingId);
        return;
    }

    yearChanged() {
        this.numberOfWeeks = moment().year(this.year).isoWeeksInYear();
        if (this.weekNumber == 53 && this.numberOfWeeks == 52) {
            this.weekNumber = 52;
        }
        this.setDateRange();
    }

    defineWeeks() {
        _.times(53, (i: number) => this.weeks.push(i));
    }

    defineYears() {
        _.times(150, (i: number) => this.years.push(1950 + i));
    }

    setCurrentYear(date?: Date) {
        this.year = moment(date ? date : new Date()).year();
        this.yearChanged();
    }

    setCurrentWeekNumber(date?: Date) {
        this.weekNumber = moment(date ? date : new Date).isoWeek();
    }

    setDateRange() {

        const dayInWeek = moment().year(this.year).isoWeek(this.weekNumber);
        this.fromDate = new Date(dayInWeek.startOf('isoweek').format('YYYY-MM-DD'));
        this.toDate = new Date(dayInWeek.endOf('isoweek').format('YYYY-MM-DD'));

        this.datesInWeek = [];
        const startDate = dayInWeek.startOf('isoweek');
        _.times(7, (i) => {
            this.datesInWeek.push(startDate.add(i === 0 ? 0 : 1, 'day').format('YYYY-MM-DD'));
        });

        this.$location.search({
            fromDate: this.$filter('date')(this.fromDate, "yyyy-MM-dd"),
            toDate: this.$filter('date')(this.toDate, "yyyy-MM-dd")
        });
    }

    setDate() {
        if (this.fromDate) {
            this.toDate = this.fromDate;
        } else {
            this.toDate = this.fromDate = new Date();
        }

        this.datesInWeek = [];
        const startDate = moment(this.fromDate).startOf('isoweek');
        _.times(7, (i) => {
            this.datesInWeek.push(startDate.add(i === 0 ? 0 : 1, 'day').format('YYYY-MM-DD'));
        });

        this.$location.search({
            fromDate: this.$filter('date')(this.fromDate, "yyyy-MM-dd"),
            toDate: this.$filter('date')(this.toDate, "yyyy-MM-dd")
        });
    }

    datePipe(date, format): string {
        return this.$filter('date')(date, format);
    }

    getPickStatusBookings() {
        this.PickStatus.getPickStatusBookings({
            fromDate: this.$filter('date')(this.fromDate, 'yyyy-MM-dd'),
            toDate: this.$filter('date')(this.toDate, 'yyyy-MM-dd'),
        }).$promise.then(
            (listOfBookings: Array<{ cars: Array<any> }>) => {
                _.forEach(this.datesInWeek, dateInWeek => {
                    _.forEach(listOfBookings[dateInWeek], (booking: any) => {
                        if (booking.deliveryDate) {
                            booking.linesRemaining =
                                booking.lineCount - booking.pickedCount
                                || 0;

                            if (booking.linesRemaining <= 0) {
                                booking.percentDone = 100;
                            } else {
                                booking.percentDone = (booking.pickedCount / booking.lineCount) * 100;
                                booking.percentDone =
                                    booking.percentDone > 100
                                        ? 100
                                        : booking.percentDone
                                        || 0;
                            }
                            return booking;
                        }
                    });
                });
                this.listOfListOfCars = listOfBookings;
                this.hasContent = _.some(this.datesInWeek, (dateInWeek: string) => this.listOfListOfCars[dateInWeek] && this.listOfListOfCars[dateInWeek].length);
            },
            (error) => this.toastService.parseError(error)
        );
    }

    rowClicked(event, car) {
        this.$state.go("loggedin.expedition_distribution_car", {
            date: this.$filter('date')(car.deliveryDate, "yyyy-MM-dd"),
            carId: car.bookingId,
            carName: car.terminals
        })
    }
}

class CarOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcCarController";
    public template: any = require('./car.html');

}

rkcApp.controller("rkcCarController", ['$state', 'PickStatus', '$filter', 'toastService', '$location', '$scope', function ($state, PickStatus, $filter, toastService, $location, $scope) {
    return new CarController($state, PickStatus, $filter, toastService, $location, $scope);
}])
    .component("rkcCar", new CarOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/distribution/car/car.ts
 **/